module.exports = __webpack_public_path__ + "media/yi5.b8bd96ce.mp4";